import TokenResource from "./TokenResource";

export default class AccountTransactionResource extends TokenResource {
	id = 0;
	backofficeApplicationId = null;
	transactionDate = null;
	description = "";
	transactionAmount = null;

	pk() {
		return this.id.toString();
	}

	static listUrl(
		searchParams?: Readonly<Record<string, string | number>> | undefined
	) {
		if (searchParams && Object.keys(searchParams).length) {
			const { backofficeApplicationId } = searchParams;
			return `${this.urlRoot}/list/${backofficeApplicationId}`;
		}
		throw new Error(
			`Couldn't retrieve Accounttransactions with backofficeApplicationId ${
				searchParams ? searchParams.backofficeApplicationId : null
			}`
		);
	}

	static urlRoot = "/api/accounttransactions";
}
